(function () {
    'use strict';

    var module = angular.module('uwAgenda.help');
    module.controller('HelpDetailController', ['$q', 'HelpService', 'Help', '$uibModalInstance', 'helpList', 'languages', 'helpCategory', 'ItemTableService', HelpDetailControllerFn]);

    /* controlle for help modal */
    function HelpDetailControllerFn($q, HelpService, Help, $uibModalInstance, helpList, languages, helpCategory, ItemTableService) {
        var vm = this;

        // list of possible languages
        vm.languages = [];
        vm.help = {};
        vm.table = null;
        vm.translations = [];
        //vm.info = { translations: [] };

        activate();

        // close modal
        vm.abort = function () {
            $uibModalInstance.dismiss("abort");
        };

        // save helpentry
        vm.save = function () {

            var i = 0;
            var items = ItemTableService.list();
            var length = items.length;
            var promises = [];

            if (0 === length) {
                // notify user that he has not submitted any content
                return;
            }

            // run through each translation notification and post to api
            for (i; i < length; i++) {

                var currentTranslation = items[i];

                // if not null
                if (typeof currentTranslation !== "undefined") {

                    // do prepare for save
                    currentTranslation.prepareForSave();
                    currentTranslation.category = helpCategory.value;

                    // remove delta 
                    if (currentTranslation.id > 0 && currentTranslation.deleted) {
                        promises.push(HelpService.remove(currentTranslation.id));
                    }
                    else {
                        if (currentTranslation.id > 0) {
                            promises.push(HelpService.update(currentTranslation.id, currentTranslation));
                        }
                        else {
                            promises.push(HelpService.save(currentTranslation));
                        }
                    }
                }
            }

            // wait for all promises
            $q.all(promises).then(function () {
                $uibModalInstance.close();
            });
        };

        /* activation work */
        function activate() {
            // help prototype
            vm.help = new Help();           

            // no language preparation -> always show all languages
            ItemTableService.data.doLanguagePreparation = false;
            // the translations
            vm.translations = helpList;
            // set requireds and languagePreparetion
            vm.requiredFields = ['caption', 'content'];
            // table service
            vm.table = ItemTableService.data;
            // set languages
            vm.languages = languages;
        }
    }
})();
